import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class AtgardService {

    getAvverkningsgruppForkortning(avverkningsgruppnamn: string): string {
        switch(avverkningsgruppnamn) {
            case "Gallring":
                return "GA";
            case "Övrig avverkning":
                return "ÖA";
            case "Föryngringsavverkning":
                return "FA";
            case "Energived":
                return "EN";
            case "Leveransvirke":
                return "LEV";
            case "Grotskotning":
                return "Grot";
            case "NS-avverkning":
                return "NS";
            case "Hyggesfri avverkning":
                return "HF";
        }
        return null;
    }

    getAvverkningsgruppColor(avverkningsgruppnamn: string): string {
        switch(avverkningsgruppnamn) {
            case "Gallring":
                return "#3F51B5";
            case "Övrig avverkning":
                return "#313131";
            case "Föryngringsavverkning":
                return "#007391";
            case "Energived":
                return "#BAD512";
            case "Leveransvirke":
                return "#00BCD4";
            case "Grotskotning":
                return "#D5C112";
            case "NS-avverkning":
                return "#805346";
            case "Hyggesfri avverkning":
                return "#313131";
        }
        return null;
    }
}
